/**
 * Clients for a picker: active ones first, then the rest (paused, prospect) with
 * their status after the name, so a project or a setting never lands on a paused
 * record by mistake. /api/clients arrives sorted by name, and each group keeps
 * that order. No imports and only erasable types, so node --test loads this file
 * directly (test/client-options.test.js).
 */
export type PickerClient = { id: number; name: string; status?: string | null };
export type PickerOption = { value: string; label: string; active: boolean };

const isActive = (client: PickerClient) => !client.status || client.status === "active";

export function clientOptions(clients: readonly PickerClient[] | null | undefined): PickerOption[] {
  const list = clients || [];
  return [...list.filter(isActive), ...list.filter((client) => !isActive(client))].map((client) => ({
    value: String(client.id),
    label: isActive(client) ? client.name : `${client.name} (${String(client.status).replaceAll("_", " ")})`,
    active: isActive(client),
  }));
}
